export const CONSENT_TEXT =
  "Details provided herein are true and I have obtained all relevant organisational consents for the purposes.";
